<div class="my-dashboard-area ptb-100">
  <div class="container">
    <div class="myDashboard-content">

      <table class="table">
        <tr>
          <td>{{"MENU.CreditPointsUsed"| translate}} </td>
          <td>{{ model?.creditPointUsed }}</td>
        </tr>
        <tr>
          <td>{{"MENU.CreditPointsHave"| translate}} </td>
          <td>{{ model?.creditPointHave }}</td>
        </tr>
        <tr>
          <td>{{"MENU.DoneRequestTotal"| translate}} </td>
          <td>{{ model?.doneRequestTotal }}</td>
        </tr>
        <tr>
          <td>{{"MENU.GenrationFreeTotal"| translate}}   </td>
          <td>{{ model?.genrationFreeCount }}</td>
        </tr>
        <tr>
          <td>{{"MENU.Date"| translate}}</td>
          <td>{{ model?.creationDate | date }}</td>
        </tr>
        <!-- Add more rows as needed for other properties -->
      </table>

      <div class="modal-footer">
        <button style="border-color:rgb(60, 56, 113) !important ; background-color: #B24EFF; color: white;" type="button"
          class="btn btn-light btn-elevate mr-2" (click)="modal.dismiss()">
          {{ "MENU.Cancel" | translate
          }}
        </button>
      </div>
      <br>
      <br>
    </div>
  </div>
</div>